import {Link} from "react-router-dom";
import {useEffect, useMemo, useState} from "react";
import {getBrands, type Brand} from "@corporatesclub/shared";
import {paths} from "@/lib/paths";
import {useI18n} from "@/components/shop/I18nProvider";

const DISPLAY_COUNT = 18;

function shuffleBrands(items: Brand[]): Brand[] {
  const pool = items.filter((b) => b.produseStoc > 0);
  const copy = [...pool];
  for(let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy.slice(0, Math.min(DISPLAY_COUNT, copy.length));
}

export function HomeBrandsMarquee() {
  const {t} = useI18n();
  const [brands, setBrands] = useState<Brand[]>([]);
  useEffect(() => {
    getBrands().then((r) => setBrands(shuffleBrands(r.items))).catch(() => {});
  }, []);
  const loop = useMemo(() => [...brands, ...brands], [brands]);
  if(!brands.length) return null;
  return (
    <section className="cc-homeBrandsMarquee" aria-labelledby="home-brands-marquee-title">
      <div className="cc-homeBrandsMarquee__inner">
        <div className="cc-homeBrandsMarquee__copy">
          <h2 id="home-brands-marquee-title" className="cc-homeBrandsMarquee__title">
            {t("Home brands marquee title")}
          </h2>
          <Link to={paths.brands} className="cc-homeBrandsMarquee__cta">
            {t("Home brands marquee cta")}
          </Link>
        </div>
        <div className="cc-homeBrandsMarquee__viewport">
          <div className="cc-homeBrandsMarquee__track" aria-hidden={false}>
            {loop.map((b, i) => (
              <Link
                key={`${b.id}-${i}`}
                to={b.url}
                className="cc-homeBrandsMarquee__brand"
                aria-label={b.nume}
              >
                {b.nume}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
